import { FormContextValues } from '@dreryk/react-common';
import { AutoLayout } from '@dreryk/react-components';

import { EntitlementStatementCreateFormBean } from '../../../entitlementStatements/create/form/EntitlementStatementCreateForm';
import { AddGrantingDateField } from '../AddGrantingDateField/AddGrantingDateField';
import { EffectiveDateField } from '../EffectiveDateField';
import { GrantingDateField } from '../GrantingDateField';
import { SubmissionDateField } from '../SubmissionDateField';

type DateSectionProps = Pick<FormContextValues<EntitlementStatementCreateFormBean>, 'register' | 'watch'>;

export const DateSection = ({ register, watch }: DateSectionProps): JSX.Element => {
   const grantingDateFieldEnabled = watch('grantingDateFieldEnabled');

   return (
      <>
         <AutoLayout as={'div'} $direction={'horizontal'} $horizontalResizing={'fill'} $spacing={24}>
            <AutoLayout as={SubmissionDateField} name={'submissionDate'} register={register} required />
            <AutoLayout as={EffectiveDateField} name={'effectiveDate'} register={register} required />
         </AutoLayout>
         <AutoLayout
            as={AddGrantingDateField}
            name={'grantingDateFieldEnabled'}
            register={register}
            required
            $horizontalResizing={'fill'}
         />
         {grantingDateFieldEnabled ? (
            <AutoLayout as={GrantingDateField} name={'grantingDate'} register={register} required />
         ) : null}
      </>
   );
};
